module.exports = __webpack_public_path__ + "static/sewing-b65af1ef74bad585b25b942ab9485be5.mp4";